import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AssetsService } from "../assets.service";
import { MessagesService } from "../../messages.service";
import * as XLSX from 'xlsx';
import * as moment from 'moment/moment';

@Component({
    selector: 'app-stock',
    templateUrl: './stock.component.html',
    styleUrls: ['./stock.component.css']
})
export class StockComponent implements OnInit {

    /*Filtros */
    public assetsSearchCriteria: any;

    public locations: any[];
    public status: any[];
    public materials: any[];
    public containers: any[];
    public dropdownSettings = {
        singleSelection: true,
        text: 'Seleccione',
        enableSearchFilter: true,
        enableFilterSelectAll: false,
        searchPlaceholderText: 'Buscar',
        showCheckbox: true,
        noDataLabel: 'Sin registros'
    };

    /*Procesamiento*/
    public countFilters: Number;
    public loadingFilters: Boolean;
    public loadingGraphs: Boolean;
    public loadingResults: Boolean;

    /*Respuesta*/
    public isFiltered: Boolean;
    public filteredDate: Date;
    public page: number = 1;
    public total: number = 0;
    public assets: any[];

    constructor(private assetsService: AssetsService, private router: Router, private route: ActivatedRoute, private messagesService: MessagesService) { }

    ngOnInit() {
        this.assetsSearchCriteria = {
            "currentLocationId": null,
            "materialCode": null,
            "containerCode": null,
            "statusCode": null
        };
        this.initLoading();
        this.isFiltered = false;
        this.filteredDate = null;
        this.assets = [];
    }

    private initLoading() {
        this.countFilters = 4;
        this.loadingFilters = true;
        this.loadLocations();
        this.loadStatus();
        this.loadMaterials();
        this.loadContainers();
    }

    loadLocations() {
        this.assetsService.getLocations('I').subscribe(
            data => { 
                this.locations = data.map(l => ({ id: l.id, itemName: l.description }));
                this.assetsSearchCriteria.currentLocationId = this.locations.filter(x=> x.id == this.route.snapshot.queryParamMap.get('location'));
                this.checkLoading(); 
            },
            error => { this.checkLoading(); this.locations = []; this.checkError(error, 'Ha ocurrido un error al cargar las ubicaciones') }
        );
    }

    loadStatus() {
        this.assetsService.getStatus().subscribe(
            data => { 
                this.status = data.map(l => ({ id: l.code, itemName: l.description }));
                this.assetsSearchCriteria.statusCode = this.status.filter(x=> x.id == this.route.snapshot.queryParamMap.get('status'));
                this.checkLoading();  
            },
            error => { this.checkLoading(); this.status = []; this.checkError(error, 'Ha ocurrido un error al cargar las estados') }
        );
    }

    loadMaterials() {
        this.assetsService.getMaterials().subscribe(
            data => { 
                this.materials = data.map(l => ({ id: l.code, itemName: l.code + ' - ' + l.description }));
                this.checkLoading();  
            },
            error => { this.checkLoading(); this.materials = []; this.checkError(error, 'Ha ocurrido un error al cargar los productos') }
        );
    }

    loadContainers() {
        this.assetsService.getContainers().subscribe(
            data => { 
                this.containers = data.map(l => ({ id: l.code, itemName: l.code + ' - ' + l.description }));
                this.checkLoading();   
            },
            error => { this.checkLoading(); this.containers = []; this.checkError(error, 'Ha ocurrido un error al cargar los envases') }
        );
    }

    private checkLoading() {
        this.countFilters = (this.countFilters.valueOf() - 1);
        if (this.countFilters == 0) {
            this.loadingFilters = false;
            
            if (this.route.snapshot.queryParamMap.keys.length > 0) {
              this.search();
            }
        }
    }

    private checkError(error: any, defaultMessage: string) {
        this.messagesService.checkError(error, defaultMessage);
    }

    public search(): void {
        let searchCriteria = {
            "currentLocationId": (this.assetsSearchCriteria.currentLocationId && this.assetsSearchCriteria.currentLocationId[0]) ? this.assetsSearchCriteria.currentLocationId[0].id : null,
            "materialCode": (this.assetsSearchCriteria.materialCode && this.assetsSearchCriteria.materialCode[0]) ? this.assetsSearchCriteria.materialCode[0].id : null,
            "containerCode": (this.assetsSearchCriteria.containerCode && this.assetsSearchCriteria.containerCode[0]) ? this.assetsSearchCriteria.containerCode[0].id : null,
            "statusCode": (this.assetsSearchCriteria.statusCode && this.assetsSearchCriteria.statusCode[0]) ? this.assetsSearchCriteria.statusCode[0].id : null
        };
        
        this.isFiltered = true;
        this.loadingResults = true;
        this.assetsService.getAssets(searchCriteria).subscribe(
            data => { this.loadingResults = false; this.assets = data; this.page = 1; this.filteredDate = new Date(); },
            error => { this.loadingResults = false; this.checkError(error, 'Ha ocurrido un error al buscar los activos'); }
        );
    }

    public getStatusClass(code: string) {
        if (code == "E") {
            return "label label-warning";
        }
        if (code == "U") {
            return "label label-info";
        }
        if (code == "F") {
            return "label label-success";
        }
        return "label label-success";
    }

    public download(): void {
        this.loadingResults = true;
        let exportable = new Array();
        exportable.push(["# Serial","Producto", "Desc. Producto", "Envase", "Desc. Envase", "Ubicación", "Estado", "Desde"]);
        this.assets.forEach(function (asset) {
            exportable.push(
             [  asset.serialNumber,
                            asset.material.code,
                            asset.material.description,
                            asset.material.code,
                            asset.material.description,
                            asset.currentLocation.location.description,
                            asset.currentLocation.status.description,
                            moment(asset.currentLocation.movement.createAuditory.date).format('YYYY-MM-DD H:mm')]
            
        );
        });
        const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(exportable);
        const wb: XLSX.WorkBook = { Sheets: { 'Stock': ws }, SheetNames: ['Stock'] };
        XLSX.writeFile(wb, 'Stock_' + moment(this.filteredDate).format('YYYY-MM-DD_H:mm') + '.xls', { bookType: 'xls', type: 'buffer' });
        
        
        this.loadingResults = false;
        
    }
}
